import { Component, h } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import Icon from '../assets'
import { BannerElementConfig } from './index.sync'
import Editor from '../../preact-components/editor'

export type TextAlignment = 'Left' |'Center' | 'Right'

interface Props extends BannerElementConfig{
  onChange: (state: State) => void
}

interface State {
  contentIsExtended: boolean
  buttonsIsExtended: boolean
  contentTextAlignment: TextAlignment
  contentTitle: string
  contentDescription: string
  buttonsPrimaryText: string
  buttonsPrimaryUrl: string
  buttonsSecondaryText?: string
  buttonsSecondaryUrl?: string
}

export const ALIGNMENTS = ['Left', 'Center', 'Right']

class BannerConfigurator extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      contentIsExtended: true,
      buttonsIsExtended: false,
      contentTextAlignment: props.content.textAlignment,
      contentTitle: props.content.title,
      contentDescription: props.content.description,
      buttonsPrimaryText: props.buttons.primaryText,
      buttonsPrimaryUrl: props.buttons.primaryUrl,
      buttonsSecondaryText: props.buttons.secondaryText,
      buttonsSecondaryUrl: props.buttons.secondaryUrl
    }

    this.notifyChanges = this.notifyChanges.bind(this)
  }

  notifyChanges() {
    this.props.onChange(this.state)
  }

  render(props: Props, {
    contentIsExtended,
    buttonsIsExtended,
    contentTitle,
    contentTextAlignment,
    contentDescription,
    buttonsPrimaryText,
    buttonsPrimaryUrl,
    buttonsSecondaryText,
    buttonsSecondaryUrl
  }: State) {
    return (
      <div className='widget-configurator_tabs-wrapper'>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-template'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ contentIsExtended: !contentIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={contentIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            CONTENT
          </div>

          {
            contentIsExtended &&
              (
                <div className='widget-configurator_tab-content'>
                  <label>Text Alignment</label>
                  <select
                    name='textAlignment'
                    className='webmasterSelector'
                    onChange={(event) => {
                      this.setState({ contentTextAlignment: (event.target as HTMLSelectElement).value as TextAlignment }, this.notifyChanges)
                    }}
                  >
                    {ALIGNMENTS.map((alignment) => <option
                      key={alignment}
                      selected={contentTextAlignment === alignment}
                                                   >{alignment}</option>)}
                  </select>
                  <InputGroup
                    title='Title'
                    type='text'
                    onChange={(event) => {
                      this.setState({ contentTitle: event.target.value }, this.notifyChanges)
                    }}
                    value={contentTitle}
                  />
                  <div className='content_description'>
                    <label>Description</label>
                    <Editor
                      isControl
                      disableFileAttachments
                      disableMentions
                      data={contentDescription}
                      CKEditor={false}
                      canHavePoll={false}
                      onChange={(content: string) => {
                        this.setState({ contentDescription: content }, this.notifyChanges)
                      }}
                    />
                  </div>
                </div>
              )
          }
        </div>
        <div className='widget-configurator_tab homepage-widget-configurator_tab-content'>
          <div className='widget-configurator_tab-header' onClick={() => this.setState({ buttonsIsExtended: !buttonsIsExtended })}>
            <div className='widget-configurator_tab-icon'>
              <Icon size={24} color='#2B3346' icon={buttonsIsExtended ? 'chevronDown' : 'chevronRight'} />
            </div>
            BUTTONS
          </div>
          {
            buttonsIsExtended &&
              (
                <div className='widget-configurator_tab-content'>
                  <InputGroup
                    title='Primary button text'
                    type='text'
                    placeholder='text'
                    onChange={(event) => {
                      this.setState({ buttonsPrimaryText: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsPrimaryText}
                  />
                  <InputGroup
                    title='Primary button URL'
                    type='url'
                    placeholder='https://example.com'
                    onChange={(event) => {
                      this.setState({ buttonsPrimaryUrl: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsPrimaryUrl}
                  />
                  <InputGroup
                    title='Secondary button text'
                    type='text'
                    placeholder='text'
                    onChange={(event) => {
                      this.setState({ buttonsSecondaryText: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsSecondaryText}
                  />
                  <InputGroup
                    title='Secondary button URL'
                    type='url'
                    placeholder='https://example.com'
                    onChange={(event) => {
                      this.setState({ buttonsSecondaryUrl: event.target.value }, this.notifyChanges)
                    }}
                    value={buttonsSecondaryUrl}
                  />
                </div>
              )
          }
        </div>
      </div>
    )
  }
}

export default BannerConfigurator
